import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from '../../Generic/Typography';
import { Button } from '../../Generic/Button';
import { getCdnImage as getImageUrl } from '../../../utils/ImageManager';
import styles from './Card-tw-styles';
import getWidth from '../../../utils/gridWidth';
import DOMPurify from 'isomorphic-dompurify';
import { CardMedia, Card, CardContent } from '../../Generic/Card';

function HorizontalCard({ cardType = 'horizontalCard', data }) {
  let cardStyle =
    (data && data.styles && styles[data.styles.trim()]) || styles[cardType];
  if (styles[data.styles] === undefined) {
    cardStyle = styles[cardType];
  }
  const widthClass = getWidth(data.componentWidth);
  return (
    <Card className={classNames(widthClass, cardStyle.card)}>
      <div className={classNames(cardStyle.mediaWrapper)}>
        {data.image && data.image ? (
          data.callToActionsCollection &&
          data.callToActionsCollection.items.length > 0 ? (
            data.callToActionsCollection.items.map(item => (
              <Button
                href={item.link}
                key={item.id}
                area-label={item.tooltip}
                title={item.tooltip}
                target={item.target}
                className={classNames(item.gaEventClass)}
                data-action-detail={item.gaEventLabel}
              >
                <CardMedia
                  className={classNames(cardStyle.cardMedia)}
                  image={
                    data.image.image &&
                    getImageUrl(data.image.image.url, { w: 800 })
                  }
                  component="img"
                  title={data.image.title}
                  alt={data.image.altText || 'img'}
                />
              </Button>
            ))
          ) : (
            data.image && data.image.image && data.image.image.url ? (
              <CardMedia
                className={classNames(cardStyle.cardMedia)}
                image={
                data.image.image &&
                getImageUrl(data.image.image.url, { w: 800 })
              }
                component="img"
                title={data.image.title}
                alt={data.image.altText}
              />
) :  (
  <CardMedia
    className={classNames(cardStyle.cardMedia)}
    image={
  data.image &&
  data.image.smartphoneImage &&
  data.image.smartphoneImage.url
}
    component="picture"
    pictureLazyLoad={
        data?.image?.name === 'Our Manifesto Imageset' ||
          data?.styles === 'BeneficialHorizontalCard' || 
          data?.styles === 'EssencialHorizontalCard'
         ? false : true
    }
    srcset={
  data.image && data.image.desktopImage && data.image.desktopImage.url
}
    alt={data.image.altText}
    cardType={cardType}
  />
)
          )
        ) : null}
      </div>
      <div className={classNames(cardStyle.contentWrapper)}>
        {data.callToActionsCollection &&
        data.callToActionsCollection.items.length > 0 ? (
          data.callToActionsCollection.items.map(item => (
            <Button
              href={item.link}
              key={item.id}
              area-label={item.tooltip}
              title={item.tooltip}
              target={item.target}
              className={classNames(item.gaEventClass)}
              data-action-detail={item.gaEventLabel}
            >
              {' '}
              <CardContent className={classNames(cardStyle.cardContent)}>
                {data.title && (
                  <Typography
                    className={classNames(cardStyle.cardTitle)}
                    component="div"
                    dangerouslySetInnerHTML={{
                      __html:DOMPurify.sanitize( data.title),
                    }}
                  />
                )}
                {data.subTitle && (
                <Typography
                  className={classNames(cardStyle.cardSubTitle)}
                  component="div"
                  dangerouslySetInnerHTML={{
                      __html:DOMPurify.sanitize( data.subTitle),
                    }}
                />
                )}

                {data.text && (
                  <Typography
                    component="div"
                    className={classNames(cardStyle.cardText)}
                    dangerouslySetInnerHTML={{
                      __html:DOMPurify.sanitize( data.text),
                    }}
                  />
                )}
                {data.supportingText && (
                <Typography
                  className={classNames(cardStyle.supportingText)}
                  component="div"
                  dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( data.supportingText),
                  }}
                />
              )}
              </CardContent>
            </Button>
          ))
        ) : (
          <CardContent className={classNames(cardStyle.cardContent)}>
            {data.title && (
              <Typography
                className={classNames(cardStyle.cardTitle)}
                component="div"
                dangerouslySetInnerHTML={{
                  __html:DOMPurify.sanitize( data.title),
                }}
              />
            )}
            {data.subTitle && (
            <Typography
              className={classNames(cardStyle.cardSubTitle)}
              component="div"
              dangerouslySetInnerHTML={{
                      __html:DOMPurify.sanitize( data.subTitle),
                    }}
            />
                )}
            {data.text && (
              <Typography
                component="div"
                className={classNames(cardStyle.cardText)}
                dangerouslySetInnerHTML={{
                  __html:DOMPurify.sanitize( data.text),
                }}
              />
            )}
            {data.supportingText && (
            <Typography
              className={classNames(cardStyle.supportingText)}
              component="div"
              dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( data.supportingText),
                  }}
            />
              )}
          </CardContent>
        )}
      </div>
    </Card>
  );
}

HorizontalCard.propTypes = {
  cardType: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};


export default HorizontalCard;
